// extracted by mini-css-extract-plugin
export default {"skillsList":"Skills_skillsList__grDMS","skillsItem":"Skills_skillsItem__DO4j6"};